export default __webpack_public_path__ + "static/media/positions-tab-active.86d0b5c9.svg";